$(() => {
    //事業所管理以外はreturn
    if (!$('#accepted-management').length) {
        return;
    }

    $('.select2').select2({
        ajax: {
            url: '/manager/corporate/get_list',
            dataType: 'json',
            delay: 250
        },
        language: "ja",
        escapeMarkup: function (markup) {
            return markup;
        }
    });


    let dualListContainer = $('select[name="students_list[]"]').bootstrapDualListbox({
        'filterPlaceHolder': '絞り込み',
        'infoText': '{0}件',
        'infoTextFiltered': '{0} から {1}<span class="label label-warning">を絞り込み</span> ',
        'filterTextClear': '全て表示',
        'infoTextEmpty': '0件',
        'preserveSelectionOnMove': '全',
        'iconsPrefix': 'fas',
        'iconMove': 'fa-angle-double-right',
        'iconRemove': 'fa-angle-double-left',
    });

    $('.moveall i').removeClass().addClass('fa fa-angle-right');
    $('.removeall i').removeClass().addClass('fa fa-angle-left');

    const student_job_info_keys = [
        'technical_document', 'employment_document', 'payment_document', 'care_school_diploma',
        'qualification_exam_document', 'technical_excam_certificate', 'exam_result', 'japaneses_exam_result',
        'visa_photo', 'passport_copy',
        'employment_background', 'class1_support_plan', 'guidance_confirmation', 'technical_assesment'
    ];

    const student_qualification_keys = ['resume', 'japaneses_proficiency_exam_result', 'jf_japaneses_exam_result'];

    const student_profile_keys = [
        'health_certificate', 'declaration_form'
    ];

    $('.student_detail').on('click', function (e) {
        let param = {};
        param.student_id = $(this).data('id');
        const is_past = ['未確認', '有り', '無し'];
        let role = $(this).data('role');
        axios.post('/' + role + '/accepted/student_info', param)
            .then((response) => {
                let student = response.data;
                $('#studentInfoModalLabel').text(student.lastname + ' ' + student.firstname);
                if (student.student_job_info) {
                    $('#passport_number').text(student.student_job_info.passport_number);
                    $('#passport_expiration_date').text(student.student_job_info.passport_expiration_date);
                    $('#expected_entry_date').text(student.student_job_info.expected_entry_date);
                    $('#visa_application_city').text(student.student_job_info.visa_application_city);

                    $.each(student.student_job_info, function (key, val) {
                        if (val) {
                            // $('#' + key).find('a').css('display', 'inline-block');
                            $('#' + key).find('a').removeClass('disabled');
                            $('#' + key).find('a').attr('href', '/' + role + '/accepted/student_info/download_file/' + student.id + '/' + key);
                        } else {
                            // $('#' + key).find('a').css('display', 'none');
                            $('#' + key).find('a').addClass('disabled');
                            $('#' + key).find('a').attr('href', '');
                        }
                    });
                } else {
                    $('#passport_number').text('');
                    $('#passport_expiration_date').text('');
                    $('#expected_entry_date').text('');
                    $.each(student_job_info_keys, function (key, column) {
                        console.log(column);
                        // $('#' + column).find('a').css('display', 'none');
                        $('#' + column).find('a').addClass('disabled');
                        $('#' + column).find('a').attr('href', '');
                    })
                }

                if (student.student_past_entry) {
                    $('#visited_to_japan').text(is_past[student.student_past_entry.visited_to_japan]);
                    $('#visit_count').text(student.student_past_entry.visit_count + '回');
                    $('#last_entry_date').text(student.student_past_entry.last_entry_date);
                    $('#is_past_work_permit').text(is_past[student.student_past_entry.is_past_work_permit]);
                    $('#past_parmit_count').text(student.student_past_entry.past_parmit_count + '回');
                    $('#revoked_parmit_count').text(student.student_past_entry.revoked_parmit_count + '回');
                    $('#is_convicted').text(is_past[student.student_past_entry.is_convicted]);
                    $('#criminal_detail').text(student.student_past_entry.criminal_detail);
                    $('#deportation_count').text(is_past[student.student_past_entry.deportation_count]);
                    $('#last_deportation_date').text(student.student_past_entry.last_deportation_date);
                } else {
                    $('#visited_to_japan').text('');
                    $('#visit_count').text('');
                    $('#last_entry_date').text('');
                    $('#is_past_work_permit').text('');
                    $('#past_parmit_count').text('');
                    $('#revoked_parmit_count').text('');
                    $('#is_convicted').text('');
                    $('#criminal_detail').text('');
                    $('#deportation_count').text('');
                    $('#last_deportation_date').text('');
                }
                if (student.student_qualification) {
                    $.each(student.student_qualification, function (key, val) {
                        if (val) {
                            // $('#' + key).find('a').css('display', 'inline-block');
                            $('#' + key).find('a').removeClass('disabled');
                            $('#' + key).find('a').attr('href', '/' + role + '/accepted/student_info/download_file/' + student.id + '/' + key);
                        } else {
                            // $('#' + key).find('a').css('display', 'none');
                            $('#' + key).find('a').addClass('disabled');
                            $('#' + key).find('a').attr('href', '');
                        }
                    });
                } else {
                    $.each(student_qualification_keys, function (key, column) {
                        console.log(column);
                        // $('#' + column).find('a').css('display', 'none');
                            $('#' + column).find('a').addClass('disabled');
                            $('#' + column).find('a').attr('href', '');
                    })
                }
                if (student.student_profile) {
                    $.each(student.student_profile, function (key, val) {
                        if (val) {
                            // $('#' + key).find('a').css('display', 'inline-block');
                            $('#' + key).find('a').removeClass('disabled');
                            $('#' + key).find('a').attr('href', '/' + role + '/accepted/student_info/download_file/' + student.id + '/' + key);
                        } else {
                            // $('#' + key).find('a').css('display', 'none');
                            $('#' + key).find('a').addClass('disabled');
                            $('#' + key).find('a').attr('href', '');
                        }
                    });

                    $('#relationship').text(student.student_profile.relationship);
                    $('#relaltive_name').text(student.student_profile.relaltive_name);
                    $('#relative_date_of_birth').text(student.student_profile.relative_date_of_birth);
                    $('#relaltive_nationality').text(student.student_profile.relaltive_nationality);
                    let living_togher = student.student_profile.is_living_together == 1 ?  '有り' : '無し';
                    $('#is_living_together').text(living_togher);
                    $('#relaltive_occupation').text(student.student_profile.relaltive_occupation);
                    $('#residence_card').text(student.student_profile.residence_card);

                } else {
                    $.each(student_profile_keys, function (key, column) {
                        console.log(column);
                        // $('#' + column).find('a').css('display', 'none');
                        $('#' + column).find('a').addClass('disabled');
                        $('#' + column).find('a').attr('href', '');
                    })
                    $('#relationship').text('');
                    $('#relaltive_name').text('');
                    $('#relative_date_of_birth').text('');
                    $('#relaltive_nationality').text('');
                    $('#is_living_together').text('');
                    $('#relaltive_occupation').text('');
                    $('#residence_card').text('');
                }

                $('#studentInfoModal').modal('show');
            }).catch(
                err => {
                    const regex = /401|403/;
                    if (err.message.match(regex)) {
                        alert('セッションが切れたため、ログイン画面へ戻ります。');
                        document.location.href = '/login';
                    } else {
                        alert(err);
                    }
                    return;
                }
            );

    })
    $('button[data-dismiss="modal"]').on('click', function () {
        $('#studentInfoModal').modal('hide');
    });
});
